import * as angular from "angular";

angular
.module('bringoz.admin.oms')
.component('omsAutomaticShipmentRulesTable', {
  bindings: {
    rules: '<',
    onEdit: '&',
    onDelete: '&',
  },
  template: require('./oms-automatic-shipment-rules-table.html').default
});
